import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import { Tabs, Tab } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { selectExhibit } from './store/exhibitReducer'


export default function HeaderBar(props) {
  const { slideChange } = props
  const exhibit = useSelector(selectExhibit)

  return (
    <AppBar style={{ background: exhibit.mainColor }}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <Tabs value={0} TabIndicatorProps={{style: {background: exhibit.secondaryColor }}}>
            <Tab label="GameDay" style={{fontSize: '46px', fontFamily: 'Teko', fontWeight: '400', lineHeight: 1, paddingTop: 12,}}/>
          </Tabs>
          <div className="nav-arrows">
            <a style={{ color: exhibit.mainColor }} onClick={() => slideChange(-1)}>&#8593;</a>
            <a style={{ color: exhibit.mainColor }} onClick={() => slideChange(+1)}>&#8595;</a>
            </div>
        </div>
    </AppBar>
  )
}
